import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { PanthersStrip } from '@/components/sections/PanthersStrip';
import { PanthersBanner } from '@/components/sections/PanthersBanner';
import { ClientPartnerStrip } from '@/components/sections/ClientPartnerStrip';
import { SignatureStatement } from '@/components/sections/SignatureStatement';
import { KGOBDifference } from '@/components/sections/KGOBDifference';
import { WorkInAction } from '@/components/sections/WorkInAction';
import { Innovation } from '@/components/sections/Innovation';
import { LatestFromJournal } from '@/components/sections/LatestFromJournal';
import { JournalSubscribeStrip } from '@/components/sections/JournalSubscribeStrip';
import { KGOBCares } from '@/components/sections/KGOBCares';
import { JoinOurCircle } from '@/components/sections/JoinOurCircle';
import { SEOSchema } from '@/components/SEOSchema';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Charlotte & Winston-Salem CPA Firm | Tax Planning & Accounting Experts | KGOB</title>
        <meta name="description" content="Partner with KGOB CPAs in Charlotte & Winston-Salem for tax planning, accounting, valuation, and IRS help. Partner-led advisory for clients nationwide." />
        <meta name="keywords" content="CPA firm, tax strategy, business valuation, IRS relief, AI financial advisor, accounting services, North Carolina CPA, Charlotte CPA, KGOB CPAs" />
        <link rel="canonical" href="https://kgob.com/" />
        <meta property="og:title" content="Charlotte & Winston-Salem CPA Firm | Tax Planning & Accounting Experts | KGOB" />
        <meta property="og:description" content="Partner with KGOB CPAs in Charlotte & Winston-Salem for tax planning, accounting, valuation, and IRS help. Partner-led advisory for clients nationwide." />
        <meta property="og:url" content="https://kgob.com/" />
        <meta property="og:type" content="website" />
      </Helmet>
      <SEOSchema />
      <Header />
      <main>
        <PanthersStrip />
        <Hero />
        <ClientPartnerStrip />
        <SignatureStatement />
        <KGOBDifference />
        <WorkInAction />
        <Innovation />
        <LatestFromJournal />
        <JournalSubscribeStrip />
        <KGOBCares />
        <JoinOurCircle />
        <PanthersBanner />
      </main>
      <Footer />
    </div>
  );
};

export default Home;